module.exports = "/virtual-football-league/img/btn-background-black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/btn-background-black.png
// module id = 326
// module chunks = 4